import { render } from "./Terminus.vue?vue&type=template&id=43353d6a&scoped=true&ts=true"
import script from "./Terminus.vue?vue&type=script&lang=ts"
export * from "./Terminus.vue?vue&type=script&lang=ts"

import "./Terminus.vue?vue&type=style&index=0&id=43353d6a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43353d6a"]])

export default __exports__